import axios from 'axios'

export default {
  getProductsForCategory  (category) {
    var query = '{ shop { collectionByHandle(handle: "' + category + '") { id handle products(first: 25) { edges { node { id handle onlineStoreUrl images(first: 1) { edges { node { id originalSrc transformedSrc altText } } } } } } } } }'

    return axios.post('https://' + process.env.VUE_APP_SHOPIFY_DOMAIN + '/api/graphql', query, {
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': process.env.VUE_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN
      },
      responseType: 'json',
      transformResponse: [ function (data) {
        return data.data.shop.collectionByHandle.products.edges.map(e => e.node)
      }]
    })
      .then(function (response) {
        return response
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}
